<template>
  <a-card title="" style="margin-top: 5px">
    <a-table :columns="columns" :data-source="data"
             size="small"
             rowKey="id"
             :scroll="{y:'300px'}"
             :pagination="false"
    >
      <span slot="action" slot-scope="text,record,index">
              <a @click="handleEdit(record)">修改</a>
        <a-divider type="vertical"/>
        <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record)">
                  <a>删除</a>
                </a-popconfirm>
      </span>
    </a-table>
    <a-button  type="primary" @click="handleAdd">添加</a-button>
    <a-modal
      title="编辑"
      :width="1000"
      :visible="formVisible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      @cancel="handleCancel">
      <a-form-model :model="formData"  layout="horizontal" style="padding-left: 20px;padding-right: 20px;"
                    v-bind="{
            labelCol: { span: 4 },
            wrapperCol: { span: 16 },
          }"
                    ref="ruleForm"
                    :rules="rules"
      >
        <a-form-model-item label="名称" prop="name">
          <a-input v-model="formData.name" />
        </a-form-model-item>
        <a-form-model-item label="英文名称" prop="nameEn">
          <a-input v-model="formData.nameEn" />
        </a-form-model-item>
        <a-form-model-item label="排序" prop="sortNum">
          <a-input-number v-model="formData.sortNum" :min="0" :precision="0" style="width: 80%"/>
        </a-form-model-item>
        <a-form-model-item label="必填">
          <a-radio-group v-model="formData.required">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="类型" prop="input">
          <a-select v-model="formData.input" placeholder="请选择类型" >
            <a-select-option :value="item.value" v-for="item in inputList" :key="item.value">{{item.text}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="验证类型" prop="checkType" v-if="formData.input==='1'">
          <a-select v-model="formData.checkType"  placeholder="请选择验证类型"  allowClear>
            <a-select-option :value="item.value" v-for="item in checkTypeList" :key="item.value">{{item.text}}</a-select-option>
          </a-select>
        </a-form-model-item>
       <template v-if="formData.input==='1'">
         <a-form-model-item label="最小长度" prop="minLength">
           <a-input-number v-model="formData.minLength" :min="0" :precision="0" style="width: 80%"/>
         </a-form-model-item>
         <a-form-model-item label="最大长度" prop="maxLength">
           <a-input-number v-model="formData.maxLength" :min="0" :precision="0" style="width: 80%"/>
         </a-form-model-item>
       </template>

        <a-form-model-item label="值域" v-if="formData.input==='4'">
          <a-table :columns="selectDataColumns" :data-source="formData.selectDataList"
                   size="small"
                   :scroll="{y:'200px'}"
          >
            <span slot="action" slot-scope="text,record,index">
                <a @click="selectUp(record,index)">上移</a>
                <a-divider type="vertical"/>
                <a @click="selectDown(record,index)">下移</a>
                <a-divider type="vertical"/>
                <a @click="handleSelectDelete(record,index)">删除</a>
            </span>
            <span slot="value" slot-scope="text,record,index">
              <a-input v-model="record.value" />
            </span>
            <span slot="text" slot-scope="text,record,index">
              <a-input v-model="record.text" />
            </span>
          </a-table>
          <a-button @click="selectDataAdd()">新增</a-button>
        </a-form-model-item>
        <a-form-model-item label="是否导出（基本信息表）">
          <a-radio-group v-model="formData.exportInfo">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="是否导出（采集数据表）">
          <a-radio-group v-model="formData.exportData">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
         <a-form-model-item label="是否显示（卡片页）">
          <a-radio-group v-model="formData.isShow">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <!-- <a-form-model-item label="是否保存为交叉索引">
          <a-radio-group v-model="formData.savePix">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
        </a-form-model-item> -->
        <a-form-model-item label="所属中心">          
          <a-select placeholder="请选择研究中心" v-model="formData.centerIds" style="width:90%;" allow-clear showSearch mode="multiple" :filterOption="filterOption">
              <a-select-option v-for="(item,index) in centerList" :key="index" :value="item.centerId">
                {{ item.center.name }}
              </a-select-option>
            </a-select>
            <a-tooltip placement="topLeft" style="padding-left:2px">
                <template slot="title">
                  该属性只适用于选择的中心；未选择中心，该属性适用项目的所有中心
                </template>
                <a-icon type="info-circle" style="color: #FF4500" />
              </a-tooltip>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import Vue from 'vue'
  import { getAction,postAction,deleteAction} from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  export default {
    name: 'PatientFieldSet',
    data(){
      return{
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        confirmLoading:false,
        selectDataList:[],
        rules:{
          name:[baseRules.required],
          nameEn:[baseRules.required],
          sortNum:[baseRules.required],
          input:[baseRules.requiredChange],
        },
        inputList:[
          {text:'文本',value:'1'},
          {text:'数字',value:'2'},
          {text:'日期',value:'3'},
          {text:'单选',value:'4'},
        ],
        checkTypeList:[
          {text:'数字',value:'number'},
          {text:'手机号',value:'phone'},
          {text:'身份证',value:'idcard'},
          {text:'邮箱',value:'email'},
        ],
        selectDataColumns:[
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 120,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '选项值',
            align:'center',
            dataIndex: 'value',
            scopedSlots: { customRender: 'value' },
          },
          {
            title: '选项名',
            align:'center',
            dataIndex: 'text',
            scopedSlots: { customRender: 'text' },
          },
          {
            title: '操作',
            align:'center',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ],
        data:[

        ],
        columns:[
          {
            title: '名称',
            align:'center',
            dataIndex: 'name',
            ellipsis: true,
            width:100,
          },
          {
            title: '英文名称',
            align:'center',
            dataIndex: 'nameEn',
            ellipsis: true,
            width:100,
          },
          {
            title: '排序',
            align:'center',
            dataIndex: 'sortNum',
            width:40,
          },
          {
            title: '必填',
            align:'center',
            dataIndex: 'required_dictText',
            width:40,
          },
          // {
          //   title: '类型',
          //   align:'center',
          //   width:100,
          //   dataIndex: 'input',
          //   // ellipsis: true, 表格省略
          //   customRender:  (t, r, index)=> {
          //     let result=''
          //     this.inputList.forEach(item=>{
          //       if(item.value===t){
          //         result=item.text
          //       }
          //     })
          //     return result;
          //   }
          // },
          // {
          //   title: '值域',
          //   align:'center',
          //   dataIndex: 'selectData',
          // },
          // {
          //   title: '验证类型',
          //   align:'center',
          //   dataIndex: 'checkType',
          //   width:100,
          //   customRender:  (t, r, index)=> {
          //     let result=''
          //     this.checkTypeList.forEach(item=>{
          //       if(item.value===t){
          //         result=item.text
          //       }
          //     })
          //     return result;
          //   }
          // },
          {
            title: '是否导出(基本信息表)',
            align:'center',
            width:100,
            dataIndex: 'exportInfo_dictText'
          },
          {
            title: '是否导出(采集数据表)',
            align:'center',
            width:100,
            dataIndex: 'exportData_dictText'
          },
          {
            title: '是否显示(卡片页)',
            align:'center',
            width:100,
            dataIndex: 'isShow_dictText'
          },
          // {
          //   title: '是否保存为交叉索引',
          //   align:'center',
          //   width:100,
          //   dataIndex: 'savePix_dictText'
          // },
          {
            title: '操作',
            align:'center',
            width:100,
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ],
        formData:{
          selectDataList:[]
        },
        formVisible:false,
        centerList: [],
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        const params = {projectId:this.projectId,type:'2'}
        getAction('/project/projectPatientField/editList',params).then(res=>{
          if(res.success){
            this.data = res.result
          }
        })
        this.loadCenter()
      },
      loadCenter(){
        getAction('/project/center/listAll', { projectId: this.projectId }).then(res => {
          if (res.success) {
            this.centerList = res.result
          }
        })
      },
      handleAdd(){
        this.handleEdit({
          projectId:this.projectId,
          name:'',
          nameEn:'',
          sortNum:1,
          required:'0',
          input:'',
          selectData:'',
          checkType:'',
          exportInfo:'0',
          exportData:'0',
          savePix:'0',
          minLength:null,
          maxLength:null,
        })
      },
      handleEdit(record){
        const formData = JSON.parse(JSON.stringify(record));
        if(formData.selectData){
          formData.selectDataList = JSON.parse(formData.selectData)
        }else{
          formData.selectDataList = []
        }
        if(formData.centerId){
          formData.centerIds = formData.centerId.split(',')
        }
        this.formData =formData
        this.formVisible = true
      },
      handleDelete(record){
        deleteAction('/project/projectPatientField/delete',{id:record.id}).then(res=>{
          if(res.success){
            this.loadData()
          }
        })
      },
      handleSubmit(){
        this.formData.selectData = ''
        if(this.formData.selectDataList && this.formData.selectDataList.length>0){
          let errorIndex = -1
          this.formData.selectDataList.forEach((item,index)=>{
            if(errorIndex ===-1){
              if(!item.text || !item.value){
                errorIndex = index
              }
            }
          })
          if(errorIndex>-1){
            return this.$message.error(`第${errorIndex+1}行值域信息不能为空`)
          }
          this.formData.selectData = JSON.stringify(this.formData.selectDataList)
        }
        if(this.formData.input!=='4'){
          this.formData.selectData=''
        }
        if(this.formData.input!=='1'){
          this.formData.minLength=''
          this.formData.maxLength=''
          this.formData.checkType=''
        }
        this.formData.type='2'
        if(this.formData.centerIds && this.formData.centerIds.length>0){
          this.formData.centerId = this.formData.centerIds.join(',');
        }
        if(this.formData.required=='0'&&this.formData.savePix=='1'){
          return this.$message.error(`交叉索引属性为是，则必填属性也必须为是`)
        }
        this.$refs.ruleForm.validate(valid  => {
          if (valid){
            this.confirmLoading = true
            postAction('/project/projectPatientField/saveOrUpdate',this.formData).then(res=>{
              if(res.success){
                this.loadData()
              }
            }).finally(()=>{
              this.confirmLoading = false
              this.handleCancel()
            })
          }
        })

      },
      handleCancel(){
        this.formData = {}
        this.formVisible = false
      },
      handleSelectDelete(record,index){
        this.formData.selectDataList.splice(index,1)
      },
      selectUp(record,index){
        this.moveList(this.formData.selectDataList,index,-1)
      },
      selectDown(record,index){
        this.moveList(this.formData.selectDataList,index,1)
      },
      moveList(list, i, num){
        list.splice(i, 0, list.splice(i + num, 1)[0]);
      },
      selectDataAdd(){
        this.formData.selectDataList.push({
          value:'',
          text:'',
        })
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
    }
  }
</script>

<style scoped>

</style>